// Keep the optional SDK import separate from result reads so its load failure
// can be exercised independently of Firestore request failures.
export const importProcessingFirestore = () => import("firebase/firestore/lite");
